let bodyStyle = {
    backgroundImage: `url(/doujinarchive/img/windowbg.jpg)`,
    backgroundRepeat: `no-repeat`
};

let ww = window.innerWidth;

export default function Window(props) {
    let winH = <table className="header-table">
    <tr className="header-row">
        <td>
            <img alt="cover art" className="cover-art" src={`/doujinarchive/img/${props.game.fileName}.png`}/>
        </td>
        <td className="game-info">
            <h2>{props.game.title}</h2>
            {(props.game.subtitle) ? <h5>{props.game.subtitle}</h5> : ""}
            <h6 className="maker">{props.game.circle}, {props.game.year}</h6>
            {props.game.para.map(para => {
                return(<p className="description">{para}</p>);
            })}
        </td>
    </tr>
</table>;

    let winV = <table className="header-table">
    <tr className="header-row">
        <td>
            <img alt="cover art" className="cover-art" src={`/doujinarchive/img/${props.game.fileName}.png`}/>
        </td>
    </tr>
    <tr>
        <td className="game-info">
            <h2>{props.game.title}</h2>
            {(props.game.subtitle) ? <h5>{props.game.subtitle}</h5> : ""}
            <h6 className="maker">{props.game.circle}, {props.game.year}</h6>
            {props.game.para.map(para => {
                return(<p className="description">{para}</p>);
            })}
        </td>
    </tr>
</table>

    return(
        <div className="window">
            <div className="window-title">
                <img alt="window icon" src={`/doujinarchive/ico/${props.game.fileName}.png`} className="window-icon"/>
                {(props.game.subtitle) ? props.game.subtitle : props.game.title}
            </div>
            <div className="window-body" style={bodyStyle}>
                {(ww > 480) ? winH : winV}
                <div className="controls">
                    {props.game.buttons.map(btn => {
                        return(<a href={btn.url}><button>{btn.title}</button></a>)
                    })}
                </div>
            </div>
        </div>
    );
}